//* Tailwind CSS Classnames 处理函数
export const clsx = {
    default: (...args: string[]) => args,
    computed: (...args: string[]) => computed(() => args),
};
